<template>
    <div>
    <div class="head">
        <div>
            <el-menu router  default-active="2"
                     mode="horizontal"
                     class="el-menu-vertical-demo"
                     @open="handleOpen"
                     @close="handleClose"
                     background-color="#f2f5f8"
                     text-color="#333333"
                     style="padding: 0 3rem">
                <el-menu-item  v-for="(item,i) in navData"  min-height="2rem" background-color="#f2f5f8">
                    <a :href="item.zhi">
<!--                        <i :class="[item.icons]" style="color: white;font-size: 1.4rem;margin-right: 0.7rem"></i>-->
                        <span slot="title">{{item.name}}</span>
                    </a>

                </el-menu-item>
            </el-menu>
        </div>
    </div>
    </div>
</template>

<script>
import utils from '../utils/utils.js'
export default {
  name: 'mynav',
  data() {
    return {
      navData: [
        { id: 1, path: '/home/main', name: '锤子工具人', isActive: true,icons:'iconfont icon-caidanguanli4',zhi:'main' },
   ],

       changeNum: 0,
       state:Boolean(utils.getStorage("user")),
       loginUser:utils.getStorage("user")
    }
  },
  methods: {
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
  }
}
</script>

<style lang='less' scoped>
@import "//at.alicdn.com/t/font_2151417_k44hicrkneh.css";
.el-menu-item{
    /*height: 4rem;*/
    text-align: center;
    i{
        font-size: 2.2rem;
        display: inline-block;
    }
    span{
        font-size: 1.4rem;
        display: inline-block;
    }
}
.head{
    display: flex;
    justify-content: space-between;
    background-color: #545c64;
}
.login{
    color: white;
    font-size: 1.4rem;
    line-height: 60px;
    margin-right: 4rem;
    cursor: pointer
}
.bgc{
      padding:1rem 5rem;
      background-image: url("https://th.bing.com/th/id/Rd52bd6d26ca8f5074a0c4bc71434a982?rik=2rUCeSMX5FP%2bnA&riu=http%3a%2f%2fimg18.3lian.com%2fd%2ffile%2f201711%2f01%2f5fdf40b537a753a87d3084907a17e00e.jpg&ehk=RSflVEgcDKM0qLgw%2ftwkmJu%2fh%2f04BV6LvNwBHew56jc%3d&risl=&pid=ImgRaw");
}
.el-menu--horizontal{
    border: none;
}
</style>